import { render, staticRenderFns } from "./InternetTable.vue?vue&type=template&id=5fb96460&scoped=true&"
import script from "./InternetTable.vue?vue&type=script&lang=js&"
export * from "./InternetTable.vue?vue&type=script&lang=js&"
import style0 from "./InternetTable.vue?vue&type=style&index=0&id=5fb96460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb96460",
  null
  
)

export default component.exports